"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClientId = void 0;
var AuthClientId;
(function (AuthClientId) {
    AuthClientId["auth"] = "auth";
    AuthClientId["admin"] = "admin";
    AuthClientId["editor"] = "editor";
    AuthClientId["learn"] = "learn";
    AuthClientId["review"] = "review";
    AuthClientId["onboarding"] = "onboarding";
    AuthClientId["billing"] = "billing";
    AuthClientId["results"] = "results";
})(AuthClientId || (exports.AuthClientId = AuthClientId = {}));
